export default __webpack_public_path__ + "static/media/box2.861bc4b6.svg";